<template>
    <div class="promociones-config-card">
        <div class="promociones-header-row">
            <input-search class="promociones-action-search" @getData="getSearch" />
            <div class="promociones-actions-row">
                <div class="position-relative d-inline-flex">
                    <select
                        v-model="selectedPromotionStatus"
                        class="btn btn-sm bg-white fw-400 select-like-btn"
                        @change="onPromotionStatusChange"
                        style="padding:0 44px;min-width:180px;text-align:center;color:black!important;border:1px solid black!important"
                    >
                        <option value="">Todos</option>
                        <option value="true">Activo</option>
                        <option value="false">Inactivo</option>
                    </select>
                    <img src="/icons/filter-recomendation.svg" alt="filter" class="icons-dark" style="position:absolute;left:10px;top:50%;transform:translateY(-50%);pointer-events:none" />
                </div>
                <button
                    class="btn btn-sm bg-white fw-400"
                    style="
                        color: black !important;
                        border: 1px solid black !important
                    "
                    @click="viewConfig('','config-promociones-options','Promociones','Actualizar estado de promoción para varios productos')"
                >
                    Configuración en lote
                </button>
                <button
                    class="btn fw-500 button-export text-white rounder-8 button-products d-flex align-items-center"
                    @click="exportDataFile"
                >
                    <img src="/icons/down.svg" alt="icono" class="me-1 icons">Exportar
                </button>
            </div>
        </div>

        <div class="promociones-table-info-row">
            <span
                class="promociones-total-count"
                v-if="totalCount > 0 && !loading"
            >
                Total: {{ totalCount }}
            </span>
        </div>

        <div class="table-responsive border" v-if="products.length > 0 || loading">
            <placeholder v-if="loading" :type="'table'" :count="3"/>
            <table class="promociones-table w-100" v-else>
                <thead>
                    <tr>
                        <th v-if="isColumnVisible('sku')">{{ getColumnLabel('sku') }}</th>
                        <th v-if="isColumnVisible('long_name')">{{ getColumnLabel('long_name') }}</th>
                        <th v-if="isColumnVisible('store_name')">{{ getColumnLabel('store_name') }}</th>
                        <th v-if="isColumnVisible('active_promotion')" class="editable-header">{{ getColumnLabel('active_promotion') }}</th>
                        <th v-if="isColumnVisible('actions')">{{ getColumnLabel('actions') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(product, index) in products" :key="index">
                        <td v-if="isColumnVisible('sku')">
                            <span class="promociones-sku-badge">{{ product.sku }}</span>
                        </td>
                        <td v-if="isColumnVisible('long_name')">{{ product.long_name || (product.product ? product.product.long_name : '') }}</td>
                        <td v-if="isColumnVisible('store_name')">{{ product.store_name || '—' }}</td>
                        <td v-if="isColumnVisible('active_promotion')" class="col-highlight">
                            <span
                                class="promociones-status-badge"
                                :class="product.active_promotion ? 'status-active' : 'status-inactive'"
                            >
                                {{ product.active_promotion ? 'Activo' : 'Inactivo' }}
                            </span>
                        </td>
                        <td v-if="isColumnVisible('actions')">
                            <div class="d-flex flex-column gap-1">
                                <span
                                    @click="viewConfig(product,'config-promociones-one','Promociones','Actualizar estado de promoción')"
                                >
                                    <img class="cursor-pointer" src="/icons/pencil-margin.svg" alt="Editar"/>
                                </span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- No data message -->
        <div v-if="products.length <= 0 && !loading" class="p-4 bg-white rounder-8 border border-1 text-center">
            <h4 class="fw-400 size-18 text-secondary">No existe información para mostrar</h4>
        </div>

        <PaginationControls
            v-if="totalCount > 0"
            :current-page="currentPage"
            :total-count="totalCount"
            :page-size="pageSize"
            @change-page="$emit('change-page', $event)"
            @change-page-size="$emit('change-page-size', $event)"
        />
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import inputSearch from '@/components/inputSearch.vue';
import Placeholder from "../../../../../components/loadings/placeholder.vue";
import PaginationControls from "../../../../../components/PaginationControls.vue";
import configsRecTableMixin from '../mixins/configsRecTableMixin.js'

export default {
    name: 'table-promociones-config',
    mixins: [configsRecTableMixin],
    components: {
        inputSearch,
        Placeholder,
        PaginationControls,
    },
    props: {
        products: { type: Array, required: true, default: () => [] },
        loading: { type: Boolean, default: false },
        totalCount: { type: Number, default: 0 },
        currentPage: { type: Number, default: 1 },
        pageSize: { type: Number, default: 25 },
    },
    data() {
        return {
            search_product: '',
            search_type: 'codigo',
            selectedPromotionStatus: '',
            tableConfigKey: 'promotions'
        };
    },
    computed: {
        ...mapGetters(["authentication_user", "activeDesk"]),
        showCluster() {
            return this.authentication_user.active_store;
        },
    },
    methods: {
        ...mapActions(["executeCommit", "get"]),
        getSearch(row) {
            this.$emit('getData', row.search, row.searchType);
        },
        onPromotionStatusChange() {
            this.$emit('filterPromotionStatus', this.selectedPromotionStatus);
        },
        viewConfig(row, name, title, text) {
            this.$emit('viewModal', row, name, title, text);
        },
        exportDataFile() {
            this.executeCommit({ mutation: "loading_state_component" });
            let url = `/api/products/export_config_promociones/?promotion_status=${this.selectedPromotionStatus}`;
            if (!this.authentication_user.client_channel) {
                url = url + `&business=${this.authentication_user.client_business_select}`;
            }
            this.get({
                url: url,
            }).then(() => {
                this.executeCommit({ mutation: "loading_state_component" });
                this.$notification.success(
                    "En un momento te llegará un correo electrónico con los datos de configuración de promociones",
                    { timer: 10, showCloseIcn: true }
                );
            });
        },
    },
};
</script>

<style scoped>
.promociones-config-card {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 24px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.promociones-header-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 1.25rem;
}

.promociones-actions-row {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
}

.promociones-table-info-row {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 0.5rem;
    margin-top: 0.25rem;
}

.promociones-total-count {
    font-size: 0.85rem;
    font-weight: 600;
    color: #6b7280;
    white-space: nowrap;
}

.promociones-action-search {
    flex: 1 1 250px;
    min-width: 0;
}

.promociones-action-search :deep(.search-container-wrapper),
.promociones-action-search ::v-deep .search-container-wrapper,
.promociones-action-search /deep/ .search-container-wrapper {
    width: 100%;
    max-width: none;
}

.promociones-action-search ::v-deep .search-wrapper,
.promociones-action-search /deep/ .search-wrapper {
    width: 100%;
}

.promociones-table {
    border-collapse: collapse;
    font-size: 0.85rem;
}

.promociones-table thead th {
    text-align: left;
    font-size: 0.7rem;
    font-weight: 700;
    color: #9ca3af;
    letter-spacing: 0.03em;
    padding: 10px 12px;
    border-bottom: 1px solid #e5e7eb;
    white-space: nowrap;
    background-color: #F3F4F6;
}

.promociones-table tbody td {
    padding: 12px;
    border-bottom: 1px solid #f3f4f6;
    vertical-align: middle;
    color: #1f2937;
}

.promociones-table tbody tr:hover {
    background: #fafafa;
}

.promociones-table thead th.editable-header {
    background-color: #E8F8F4;
    color: #087F6A;
    font-weight: 700;
}

.promociones-table tbody td.col-highlight {
    background-color: #F8FCFB;
}

.promociones-sku-badge {
    display: inline-block;
    background: #f3f4f6;
    color: #374151;
    font-size: 0.78rem;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 6px;
}

.promociones-status-badge {
    display: inline-block;
    font-size: 0.78rem;
    font-weight: 600;
    padding: 4px 10px;
    border-radius: 20px;
    white-space: nowrap;
}

.status-active {
    background: #d1fae5;
    color: #065f46;
}

.status-inactive {
    background: #f3f4f6;
    color: #4b5563;
}

@media (max-width: 991.98px) {
    .promociones-actions-row {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 0.5rem;
        width: 100%;
        align-items: stretch;
    }

    .promociones-actions-row > * {
        box-sizing: border-box;
        min-width: 0;
        width: 100%;
    }

    .promociones-actions-row .btn,
    .promociones-actions-row select {
        width: 100%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
}

.promociones-actions-row .btn {
    height: 44.8px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
}

.promociones-actions-row select {
    height: 44.8px;
}

.promociones-actions-row select:hover {
    background-color: #f8f9fa !important;
    color: #212529 !important;
}

select.select-like-btn::-ms-expand { display: none; }

.button-export {
    background-color: #021418;
}

.button-products {
    padding: 10.5px 20px !important;
}

.icons {
    filter: brightness(0) invert(1);
    width: 20px;
    height: 20px;
}

.icons-dark {
    filter: brightness(0);
    width: 18px;
    height: 18px;
}
</style>
